const Warning = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" x="0px" y="0px">
    <g data-name="Layer 19">
      <path
        fill="#000"
        d="M29.56,23.68,18.82,5.07a3.25,3.25,0,0,0-5.64,0L2.44,23.68a3.26,3.26,0,0,0,2.82,4.88H26.74a3.26,3.26,0,0,0,2.82-4.88Zm-1.73,2.25a1.23,1.23,0,0,1-1.09.63H5.26a1.23,1.23,0,0,1-1.09-.63,1.22,1.22,0,0,1,0-1.25L14.92,6.07a1.24,1.24,0,0,1,2.16,0L27.83,24.68A1.22,1.22,0,0,1,27.83,25.93ZM15,19.36V10.91a1,1,0,0,1,2,0v8.45a1,1,0,0,1-2,0Zm2.53,3.7A1.53,1.53,0,1,1,16,21.53,1.54,1.54,0,0,1,17.53,23.06Z"
      />
    </g>
  </svg>
);

export default Warning;
